import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'ui-contact-alert',
  standalone: true,
  imports: [MatIcon],
  templateUrl: './contact-alert.component.html',
  styleUrl: './contact-alert.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactAlertComponent {
  readonly message = input.required<string>();
  readonly linkText = input<string>();
  readonly linkHref = input<string>();
}
